import axios from '../axios';
import { getURL } from '../utils/config';
import { getLiveStreamApiURL } from './liveZones';

export const getLiveDailyReportTimezone = async (timezoneId, { signal } = {}) => {
  if (!timezoneId) throw new Error('No timezone ID is configured for this client.');
  const response = await axios.get(getURL('timezone'), {
    params: { status: 1, id: timezoneId }, signal, timeout: 30000,
  });
  const rows = Array.isArray(response.data) ? response.data : [response.data];
  const timezone = rows.find((row) => String(row?.Id) === String(timezoneId))?.TimeZoneName;
  if (typeof timezone !== 'string' || !timezone.trim()) throw new Error('Timezone name unavailable for this client.');
  // Validate the IANA name before using it for display or API requests.
  new Intl.DateTimeFormat('en-GB', { timeZone: timezone.trim() }).format();
  return timezone.trim();
};

export const getLiveCameraDailyReport = async ({ cameraId, timezone, signal }) => {
  const response = await axios.get(getLiveStreamApiURL(`cameras/${encodeURIComponent(cameraId)}/daily-report`), {
    params: { timezone }, signal, timeout: 30000,
  });
  if (!response.data || !Array.isArray(response.data.hours) || !Array.isArray(response.data.zones)) {
    throw new Error('Invalid daily report response');
  }
  return response.data;
};
